import React from 'react';
import CenteredContent from '@local/common/ui/components/layout/CenteredContent';
import DefaultLayout, {
    DefaultLayoutProps,
} from '@local/common/ui/components/layout/DefaultLayout';

const CenteredLayout = ({
    headerProps,
    shouldShowFooter = true,
    dataTestId = 'centered-layout',
    children,
}: React.PropsWithChildren<DefaultLayoutProps>) => {
    return (
        <DefaultLayout
            headerProps={headerProps}
            shouldShowFooter={shouldShowFooter}
            dataTestId={dataTestId}
        >
            <CenteredContent>{children}</CenteredContent>
        </DefaultLayout>
    );
};

export default CenteredLayout;
